import discardFocusedInboxOption from './actions/discardFocusedInboxOption';
import saveFocusedInboxOption, { saveFocusedInboxQuickOption, } from './actions/saveFocusedInboxOption';
import FocusedFull from './components/FocusedFull';
import isFocusedInboxOptionDirty from './utils/isFocusedInboxOptionDirty';
import * as React from 'react';
import { getUserConfiguration } from 'owa-session-store';
var FocusedInboxOption = {
    key: 'focused',
    titleStringKey: 'optionTitle_focusedInbox',
    searchTermsStringKey: 'optionTitle_focusedInbox',
    fullOptionFormSettings: {
        render: function () { return React.createElement(FocusedFull, null); },
        isDirty: isFocusedInboxOptionDirty,
        onSave: saveFocusedInboxOption,
        onDiscard: discardFocusedInboxOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () { return getUserConfiguration().UserOptions.IsFocusedInboxEnabled; },
            onToggle: saveFocusedInboxQuickOption,
        },
        order: 4 /* Focused */,
        workloads: 1 /* Mail */,
        tooltip: {
            tooltipStringKey: 'options_focused_enabled',
        },
    },
};
export default FocusedInboxOption;
//# sourceMappingURL=FocusedInboxOption.js.map